module.exports = __webpack_public_path__ + "img/kl.3fd508eb.svg";